import { IURLParams } from "../interfaces";
import { ActiveTabEnum, GameTypeEnum } from "../enums";
import { setActiveTab } from "../store/picks/tabs-slice";
import store from "../store/store";

const lowercaseKeys = (obj: any): any => {
  const entries = Object.entries(obj);

  return Object.fromEntries(
    entries.map(([key, value]) => [key.toLowerCase(), value])
  );
};

export const getParamsFromURL = (): IURLParams => {
  const urlParams = new URLSearchParams(window.location.search);
  const paramsObject = Object.fromEntries(urlParams.entries());
  const newParamsObject = lowercaseKeys(paramsObject);

  const { useruuid, userid, instance, partner, sessionid } = newParamsObject;

  const userUuid = useruuid || userid;
  const sessionId = sessionid;

  return {
    userUuid,
    instance,
    partner,
    game: "BergmannRoulette",
    ...(sessionId !== null && { sessionId }),
  };
};

export const checkProdURLParams = (urlParams: IURLParams): boolean =>
  urlParams.userUuid !== undefined &&
  urlParams.userUuid !== null &&
  urlParams.userUuid !== "" &&
  urlParams.instance !== undefined &&
  urlParams.instance !== null &&
  urlParams.instance !== "" &&
  urlParams.partner !== undefined &&
  urlParams.partner !== null &&
  urlParams.partner !== "";

export const checkDemoUrlParams = (urlParams: IURLParams): boolean =>
  urlParams.partner !== undefined &&
  urlParams.partner !== null &&
  urlParams.partner !== "";

export const getGameTypeFromPath = (): GameTypeEnum => {
  let gameType = GameTypeEnum.ONLINE;
  store.dispatch(setActiveTab(ActiveTabEnum.PLAY));
  if (window.location.pathname.toLowerCase().includes("/panel")) {
    gameType = GameTypeEnum.PANEL;
    store.dispatch(setActiveTab(ActiveTabEnum.PLAY));
  } else if (window.location.pathname.toLowerCase().includes("/presentation")) {
    gameType = GameTypeEnum.PRESENTATION;
    store.dispatch(setActiveTab(ActiveTabEnum.DRAW));
  }
  return gameType;
};

export const getTempTokenFromURL = (): string | null =>
  new URLSearchParams(window.location.search.toLowerCase()).get("temptoken");
